(() => {
  const SHORTCODE_REGEX = /\[product="([^"]+)"(?:\s+titre="([^"]+)")?\]/gi;

  // Protections globales
  let isRendering = false;
  let observerStarted = false;

  /* --------------------------------------------------------------------------
   * Utils
   * -------------------------------------------------------------------------- */

  function getArticleRoot() {
    return (
      document.querySelector('.blog-post-content rte-formatter') ||
      document.querySelector('.blog-post-content') ||
      document.querySelector('article rte-formatter') ||
      document.querySelector('article')
    );
  }

  function formatMoneyCents(cents) {
    const v = (Number(cents) / 100).toFixed(2).replace('.', ',');
    return `${v} €`;
  }

  async function loadMap() {
    const url = window.__PRESTASHOP_MAP_URL__;
    if (!url) throw new Error('Map URL manquante');
    const res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) throw new Error(`Impossible de charger le mapping (${res.status})`);
    return res.json();
  }

  async function fetchProduct(handle) {
    const res = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
    if (!res.ok) throw new Error(`Produit non accessible: ${handle}`);
    return res.json();
  }

function getHandleFromProduct(product) {
  const url = product?.url || '';
  const m = url.match(/\/products\/([^/?#]+)/);
  return m ? m[1] : '';
}


async function fetchRatings(handles) {
  if (!handles?.length) return {};

  const uniq = Array.from(new Set(handles.filter(Boolean)));

  const results = await Promise.allSettled(
    uniq.map(async (h) => {
      const res = await fetch(`/products/${h}?view=rating-json`, { credentials: 'same-origin' });
      if (!res.ok) throw new Error(`rating-json non accessible: ${h} (${res.status})`);
      const data = await res.json();
      const rating = Number(data?.rating) || 0;
      const count = Number(data?.count) || 0;
      return [h, { rating, count }];
    })
  );

  const map = {};
  for (const r of results) {
    if (r.status === 'fulfilled') {
      const [h, obj] = r.value;
      map[h] = obj;
    }
  }
  return map;
}


function buildRatingNode(rating, count) {
  const wrap = document.createElement('div');
  wrap.className = 'article-product-card__rating';

  const stars = document.createElement('span');
  stars.className = 'apc-stars';

  const r = Number(rating) || 0;
  const pct = Math.max(0, Math.min(100, (r / 5) * 100));
  stars.style.setProperty('--pct', `${pct}%`);
  stars.setAttribute('aria-label', `${r.toFixed(1)} / 5`);

  wrap.appendChild(stars);

  if (count != null) {
    const c = document.createElement('span');
    c.className = 'apc-rating-count';
    c.textContent = `(${Number(count) || 0})`;
    wrap.appendChild(c);
  }

  return wrap;
}

  /* --------------------------------------------------------------------------
   * Shortcode → placeholder (TextNodes only)
   * -------------------------------------------------------------------------- */

  function replaceShortcodesWithPlaceholders(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    for (const textNode of nodes) {
      const text = textNode.nodeValue;
      if (!text || !text.includes('[product=')) continue;

      SHORTCODE_REGEX.lastIndex = 0;

      let match;
      let lastIndex = 0;
      const frag = document.createDocumentFragment();
      let found = false;

      while ((match = SHORTCODE_REGEX.exec(text)) !== null) {
        found = true;

        if (match.index > lastIndex) {
          frag.appendChild(document.createTextNode(text.slice(lastIndex, match.index)));
        }

        const idsRaw = (match[1] || '').trim();
        const title = (match[2] || '').trim();

        const wrap = document.createElement('div');
        wrap.className = 'article-product-embed';
        wrap.setAttribute('data-products', idsRaw);
        if (title) wrap.setAttribute('data-title', title);

        frag.appendChild(wrap);
        lastIndex = match.index + match[0].length;
      }

      if (!found) continue;

      if (lastIndex < text.length) {
        frag.appendChild(document.createTextNode(text.slice(lastIndex)));
      }

      textNode.parentNode.replaceChild(frag, textNode);
    }
  }

  /* --------------------------------------------------------------------------
   * Shortcode wrapped by spans (Shopify editor) → placeholder
   * - Handles cases like: "[product="" + <span>handles</span> + ""]"
   * - Only when the shortcode is the ONLY content of the element (p/li/div)
   * -------------------------------------------------------------------------- */

  function replaceElementWrappedShortcodes(root) {
    const candidates = root.querySelectorAll('p, li, div');

    for (const el of candidates) {
      const rawText = (el.textContent || '').trim();
      if (!rawText.includes('[product=')) continue;

      SHORTCODE_REGEX.lastIndex = 0;
      const m = SHORTCODE_REGEX.exec(rawText);
      if (!m) continue;

      // Sécurité : on ne remplace que si le bloc ne contient QUE le shortcode
      if ((m[0] || '').trim() !== rawText) continue;

      const idsRaw = (m[1] || '').trim();
      const title = (m[2] || '').trim();

      const wrap = document.createElement('div');
      wrap.className = 'article-product-embed';
      wrap.setAttribute('data-products', idsRaw);
      if (title) wrap.setAttribute('data-title', title);

      el.replaceWith(wrap);
    }
  }

  /* --------------------------------------------------------------------------
   * Card rendering
   * -------------------------------------------------------------------------- */

  function buildCard(product, ratingData) {
  const a = document.createElement('a');
  a.className = 'article-product-card';
  a.href = product.url;

  const img = document.createElement('img');
  img.className = 'article-product-card__img';
  img.loading = 'lazy';
  img.alt = product.title || '';
  img.src = (product.featured_image || '').split('?')[0];
  a.appendChild(img);

  const body = document.createElement('div');
  body.className = 'article-product-card__body';

  const title = document.createElement('div');
  title.className = 'article-product-card__title';
  title.textContent = product.title || '';
  body.appendChild(title);

  // ⭐ Rating Judge.me (si dispo)
  if (ratingData && Number(ratingData.rating) > 0) {
    body.appendChild(buildRatingNode(ratingData.rating, ratingData.count));
  }

  const v = product.variants?.[0];
  const priceWrap = document.createElement('div');
  priceWrap.className = 'article-product-card__price';

  if (v?.price != null) {
    const price = document.createElement('span');
    price.className = 'article-product-card__price-current';
    price.textContent = formatMoneyCents(v.price);
    priceWrap.appendChild(price);

    if (v.compare_at_price && Number(v.compare_at_price) > Number(v.price)) {
      const compare = document.createElement('s');
      compare.className = 'article-product-card__price-compare';
      compare.textContent = formatMoneyCents(v.compare_at_price);
      priceWrap.appendChild(compare);
    }
  }

  body.appendChild(priceWrap);

  const cta = document.createElement('div');
  cta.className = 'article-product-card__cta';
  cta.textContent = 'Voir le produit';
  body.appendChild(cta);

  a.appendChild(body);
  return a;
}


  function renderError(embed, msg) {
    const el = document.createElement('div');
    el.className = 'article-product-embed__error';
    el.textContent = msg;
    embed.appendChild(el);
  }

  /* --------------------------------------------------------------------------
   * Mobile progress bar (50% → 100%)
   * -------------------------------------------------------------------------- */

  function setupMobileProgress(embed, grid) {
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    const cards = grid.querySelectorAll('.article-product-card');
    if (cards.length <= 2) return;
    if (embed.querySelector('.article-product-embed__progress')) return;

    const wrap = document.createElement('div');
    wrap.className = 'article-product-embed__progress';

    const bar = document.createElement('div');
    bar.className = 'article-product-embed__progress-bar';

    wrap.appendChild(bar);
    embed.appendChild(wrap);

    const update = () => {
      const maxScroll = grid.scrollWidth - grid.clientWidth;
      if (maxScroll <= 0) {
        bar.style.width = '100%';
        return;
      }
      const ratio = Math.min(1, Math.max(0, grid.scrollLeft / maxScroll));
      bar.style.width = `${50 + ratio * 50}%`;
    };

    grid.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    window.addEventListener('resize', () => requestAnimationFrame(update));
    update();
  }

  /* --------------------------------------------------------------------------
   * Main rendering
   * -------------------------------------------------------------------------- */

  async function renderEmbedsOnce(root) {
  if (isRendering) return;
  isRendering = true;

  try {
    const embeds = Array.from(root.querySelectorAll('.article-product-embed')).filter(
      (e) => e.getAttribute('data-rendered') !== '1'
    );

    if (!embeds.length) return;

    let map = {};
    try {
      map = await loadMap();
    } catch (_) {}

    for (const embed of embeds) {
      embed.setAttribute('data-rendered', '1');

      const raw = embed.getAttribute('data-products') || '';
      const title = embed.getAttribute('data-title') || '';
      const tokens = raw
        .split(',')
        .map((t) => t.trim())
        .filter(Boolean);

      if (title) {
        const h = document.createElement('h3');
        h.className = 'article-product-embed__title';
        h.textContent = title;
        embed.appendChild(h);
      }

      const grid = document.createElement('div');
      grid.className = 'article-product-embed__grid';
      embed.appendChild(grid);

      const handles = Array.from(
        new Set(
          tokens
            .map((t) => (/^\d+$/.test(t) ? map[t] : t))
            .filter(Boolean)
        )
      );

      if (!handles.length) {
        renderError(embed, `Aucun produit trouvé pour: ${tokens.join(', ')}`);
        continue;
      }

      const results = await Promise.allSettled(handles.map((h) => fetchProduct(h)));

      const products = [];
      results.forEach((r) => {
        if (r.status === 'fulfilled') products.push(r.value);
      });

      if (!products.length) {
        renderError(embed, 'Aucun produit disponible.');
        continue;
      }

      // ⭐ Judge.me ratings (metafields via section endpoint)
let ratingsMap = {};
try {
  const handlesForRatings = products.map(getHandleFromProduct).filter(Boolean);
  ratingsMap = await fetchRatings(handlesForRatings);

} catch (_) {
  ratingsMap = {};
}

products.forEach((p) => {
  const h = getHandleFromProduct(p);
  grid.appendChild(buildCard(p, ratingsMap[h]));
});

      setupMobileProgress(embed, grid);
    }
  } finally {
    isRendering = false;
  }
}


  /* --------------------------------------------------------------------------
   * Init
   * -------------------------------------------------------------------------- */

  function init() {
    const root = getArticleRoot();
    if (!root) return;

    if (root.getAttribute('data-product-embed-init') === '1') return;
    root.setAttribute('data-product-embed-init', '1');

    // 1) Remplacement via TextNodes
    replaceShortcodesWithPlaceholders(root);
    // 2) Remplacement quand Shopify a injecté des <span> dans le shortcode
    replaceElementWrappedShortcodes(root);

    if (root.querySelector('.article-product-embed')) {
      renderEmbedsOnce(root);
      return;
    }

    if (observerStarted) return;
    observerStarted = true;

    const observer = new MutationObserver(() => {
      replaceShortcodesWithPlaceholders(root);
      replaceElementWrappedShortcodes(root);

      if (root.querySelector('.article-product-embed')) {
        observer.disconnect();
        renderEmbedsOnce(root);
      }
    });

    observer.observe(root, { childList: true, subtree: true });
    setTimeout(() => observer.disconnect(), 5000);
  }

  document.addEventListener('DOMContentLoaded', init);
})();
